module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/nano_01-d059ec72765d56efbdd7b45d2e05b834.png";